module.exports = __webpack_public_path__ + "img/宣传_216.ae07e635.jpg";